import React from 'react';
import styled from 'styled-components';
import { UserAvailabilityType } from '../api';
import { mb } from '../common/theme/mbTokens';

const StyledCircle = styled.div`
  width: 10px;
  height: 10px;
  border-radius: 2px;
  border: 1px solid ${mb.ink};
`;

export const AvailabilityCircle = ({ type = 'working_days' }: { type?: UserAvailabilityType | 'working_days' }) => {
  let backgroundColor: string = mb.ink;
  if (type === UserAvailabilityType.AVAILABLE) {
    backgroundColor = mb.green;
  }
  if (type === UserAvailabilityType.BLOCKED) {
    backgroundColor = mb.danger;
  }
  return <StyledCircle style={{ backgroundColor }} />;
};
